import { Select } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { SortOffers } from 'shared/components/OfferHistory/components';
import { useHandleSortOffersChange } from 'shared/components/OfferHistory/containers/utils/useHandleSortOffersChange';
import { SORT_OFFERS_HISTORY_BY } from 'shared/components/OfferHistory/types';
import { selectAdminAccess } from 'shared/selectors/offersHistory';

export const SortOffersContainer: React.FC = () => {
  const handleChange = useHandleSortOffersChange();
  const isAdminAccess = useSelector(selectAdminAccess);

  if (!isAdminAccess) {
    return null;
  }

  return (
    <SortOffers>
      <Select title="Выберите тип сортировки" onChange={handleChange} options={SORT_OFFERS_HISTORY_BY} />
    </SortOffers>
  );
};
